// document.addEventListener("DOMContentLoaded", function () {

//   setTimeout(() => {
//     const productMetas = document.querySelectorAll(".product-item__inner .product-item__media");
//     console.log("productMetas", productMetas);
//     const meta = document.querySelector(".product__meta");
//     productMetas.forEach((productMeta) => {
//       const reviewWrapper = productMeta.querySelector("#epr-product-collection-review");
//     console.log("reviewWrapper", reviewWrapper)

//       if (!reviewWrapper) return;

//       const productId = reviewWrapper.getAttribute("data-product-id");
//       if (!productId) return;

//       const reviewBlock = reviewWrapper.querySelector("span");
//       if (!reviewBlock) return;

//       const meta = productMeta.closest(".product-item__inner")?.querySelector(".product-item__meta");
//       if (!meta) return;

//       const rating = meta.dataset.rating;
//       const reviews = meta.dataset.review;

//       if (rating) {
//         reviewBlock.innerHTML = `
//         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffc800" class="bi bi-star-fill" viewBox="0 0 16 16">
//           <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
//         </svg>
//         ${rating}${reviews ? ` (${reviews})` : ""}
//       `;
//         // ✅ Show wrapper only after content is injected
//       }
//       reviewWrapper.style.display = "block";
//     });
//   }, 4000);
//   setTimeout(() => {
//     // Product page
//     const meta = document.querySelector(".product__meta");

//     const reviewWrapper = document.querySelector("#epr-product-title-review");
//     if (!meta || !reviewWrapper) return;

//     const reviewBlock = reviewWrapper.querySelector("span");
//     if (!reviewBlock) return;

//     const rating = meta.dataset.rating;
//     const reviews = meta.dataset.review;

//     if (rating) {
//       reviewBlock.innerHTML = `
//       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffc800" class="bi bi-star-fill" viewBox="0 0 16 16">
//         <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
//       </svg>
//       ${rating}${reviews ? ` | ${reviews} Ratings` : ""}
//     `;
//     }
//     reviewWrapper.style.display = "block";
//   }, 1000)
//   setTimeout(() => {
//     const meta = document.querySelector(".product__meta");

//     const reviewWrap = document.querySelector(".mag-review-count-wrapper");
//     console.log(".mag-review-count-wrapper", reviewWrap)


//     if (meta && reviewWrap) {
//       const rating = meta.dataset.rating;
//       const reviews = meta.dataset.review;

//       if (rating) {
//         // Intersection Observer for when reviewWrap comes into view
//         const observer = new IntersectionObserver((entries, observer) => {
//           entries.forEach(entry => {
//             if (entry.isIntersecting) {
//               // Create new div when element is visible
//               const newDiv = document.createElement("div");
//               newDiv.className = "product-page-rating";
//               newDiv.innerHTML = `
            
//               ${reviews ? ` ${reviews} Ratings` : ""}
//             `;
//               reviewWrap.insertAdjacentElement("afterend", newDiv);
//               observer.unobserve(entry.target);
//             }
//           });
//         }, {
//           threshold: 0.2 // trigger when 20% visible
//         });

//         observer.observe(reviewWrap);
//       }
//     }
//   }, 5000)
// });


window.theme.offerSecSlider = () => {
  var mySwiper = new Swiper('.discount-code-desc-main.swiper', {
    loop: true,
    parallax: true,
    slidesPerView: 1,
    pagination: {
      el: '.discount-code-desc-main .swiper-pagination',
      clickable: true,
    },
    speed: 1000,
    autoplay: true,
    disableOnInteraction: true,
    observer: true,
    observeParents: true
  });
  // check if element exists before accessing swiper property
  const swiperEl = document.querySelector('.discount-code-desc-main.swiper');
  if (!swiperEl) return;

  var mySwiperInstance = swiperEl.swiper;

  const el = document.querySelector(".discount-code-desc-main.swiper");
  if (el) {
    el.addEventListener("mouseenter", function () {
      if (mySwiperInstance && mySwiperInstance.autoplay) {
        mySwiperInstance.autoplay.stop();
        console.log('slider stopped');
      }
    });
    el.addEventListener("mouseleave", function () {
      if (mySwiperInstance && mySwiperInstance.autoplay) {
        mySwiperInstance.autoplay.start();
        console.log('slider started again');
      }
    });
  }

}

document.addEventListener('DOMContentLoaded', function () {
  // document.addEventListener('click', function(e) {
  //     if (e.target.classList.contains('acco-title')) {
  //         e.target.classList.toggle('active');
  //         const content = e.target.nextElementSibling;
  //         if (content && content.classList.contains('acco-content')) {
  //             // Simple slide toggle emulation
  //             if (content.style.display === 'none' || !content.style.display) {
  //                 content.style.display = 'block';
  //             } else {
  //                 content.style.display = 'none';
  //             }
  //         }
  //     }
  // })
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('acco-title')) {
      e.target.classList.toggle('active');
    }
  })

  if (window.theme && window.theme.offerSecSlider) {
    window.theme.offerSecSlider();
  }

  const loader = document.querySelectorAll('.codecopy-loader');
  loader.forEach(el => el.style.display = 'none');

  document.addEventListener('click', function (e) {
    const discountCodeEl = e.target.closest('div.discount-code-snippet .discount-code');
    if (discountCodeEl) {
      e.preventDefault();
      var current = discountCodeEl.previousElementSibling; // assuming .discount-success-msg is sibling before or use querySelector
      if (!current || !current.classList.contains('discount-success-msg')) {
        current = discountCodeEl.parentNode.querySelector('.discount-success-msg');
      }

      var curr = discountCodeEl.querySelector('span');
      var discount_code = discountCodeEl.dataset.id;
      var loaderclass = discountCodeEl.parentNode.querySelector('.codecopy-loader');

      if (loaderclass) loaderclass.style.display = 'inline-block'; // or block
      if (current) current.style.display = 'none';

      fetch(`/discount/${discount_code}`)
        .then(response => {
          if (loaderclass) loaderclass.style.display = 'none';
          if (current) {
            current.style.display = 'block';
            current.innerHTML = 'Code applied';
          }
          if (curr) {
            curr.classList.remove('before-apply');
            curr.classList.add('after-apply');
          }
        })
        .catch(err => {
          console.error('Discount apply error:', err);
          if (loaderclass) loaderclass.style.display = 'none';
        });
    }
  });

})